<p-sidebar [(visible)]="visible" position="right" [style]="{'width': '350px'}" appendTo="body"
           (onHide)="visible = false">
    <ng-template pTemplate="header">
        <span class="font-semibold text-xl">Filter</span>
    </ng-template>
    <div class="flex flex-column">
        <form [formGroup]="globalFilterForm">
            <div class="flex flex-row gap-1">
                <div class="flex flex-column gap-2 mb-4 w-full" *ngIf='additionalFields["yearPicker"].visible'>
                    <label for="username" class="text-black-alpha-90">Year</label>
                    <p-dropdown [options]="yearArr" formControlName="Year"
                        optionLabel="Label" placeholder="Year" (onChange)="onYearChange()"/>
                </div>
                <div class="flex flex-column gap-2 mb-4 w-full" *ngIf='additionalFields["monthPicker"].visible'>
                    <label for="username" class="text-black-alpha-90">Month</label>
                    <p-dropdown [options]="monthArr" formControlName="Month"
                        optionLabel="Label" placeholder="Month"/>
                </div>
                <div class="flex flex-column gap-2 mb-4 w-full" *ngIf='additionalFields["quarterPicker"].visible'>
                    <label for="username" class="text-black-alpha-90">Quarter</label>
                    <p-dropdown [options]="quarterArr" formControlName="Quarter"
                        optionLabel="label" placeholder="Quarter"/>
                </div>
            </div>
            <div class="flex flex-column gap-2 mb-2" *ngIf='additionalFields["fromDatePicker"].visible'>
                <label for="username" class="text-black-alpha-90">From Date</label>
                <p-calendar formControlName="FromDate" [iconDisplay]="'input'" [showIcon]="true" inputId="iconDisplay" [style]="{'width': '400px'}"/>
            </div>
            <div class="flex flex-column gap-2 mb-4" *ngIf='additionalFields["toDatePicker"].visible'>
                <label for="username" class="text-black-alpha-90">To Date</label>
                <p-calendar formControlName="ToDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" [style]="{'width': '400px'}"/>
            </div>
            <div class="flex flex-column gap-2 mb-4" *ngIf='additionalFields["tillDatePicker"].visible'>
                <label for="username" class="text-black-alpha-90">Till Date</label>
                <p-calendar formControlName="TillDate" [iconDisplay]="'input'" [showIcon]="true" inputId="icondisplay" [style]="{'width': '400px'}"/>
            </div>
            <div class="flex flex-row gap-1">
                <div class="flex flex-column gap-2 mb-4 w-full" *ngIf='additionalFields["rTypeFilter"].visible'>
                    <label for="username" class="text-black-alpha-90">View By</label>
                    <p-dropdown [options]="rTypeOption" formControlName="RType"
                        optionLabel="label" placeholder="Select a Value"/>
                </div>
                <div class="flex flex-column gap-2 mb-4 w-full" *ngIf='additionalFields["sTypeFilter"].visible'>
                    <label for="username" class="text-black-alpha-90">Filter By</label>
                    <p-dropdown [options]="sTypeOption" formControlName="SType"
                        optionLabel="label" placeholder="Select Value"/>
                </div>
            </div>
            <div class="flex flex-row align-items-center justify-content-center" *ngIf="!dataLoaded && this.additionalFields['hierarchyControls'].visible">
                <p-progressSpinner ariaLabel="loading" />
            </div>
            <div class="flex flex-column" *ngIf="dataLoaded && this.additionalFields['hierarchyControls'].visible">
                <div class="flex flex-row align-items-end justify-content-end">
                    <p-button label="Reset All" [text]="true" severity="danger" icon="pi pi-sync" (click)="resetFilterFormData()"/>
                </div>
                <div class="flex flex-column gap-2 mb-4">
                    <p-multiSelect [options]="hierarchyData.Region" formControlName="Region" 
                        optionLabel="RegionName" placeholder="Select Region" display="chip" [showClear]="true"/>
                    <p-multiSelect [options]="hierarchyData.SubRegion| hierarchyFilter:'RegionName':formData['Region'].value" formControlName="SubRegion" 
                        optionLabel="SubRegionName" placeholder="Select Sub Region" display="chip" [showClear]="true"/>
                    <p-multiSelect [options]="hierarchyData.Cluster | hierarchyFilter:(formData['SubRegion'].value && formData['SubRegion'].value.length>0?'SubRegionName':'RegionName'):(formData['SubRegion'].value && formData['SubRegion'].value.length>0?formData['SubRegion'].value:formData['Region'].value)" formControlName="Cluster" 
                        optionLabel="ClusterName" placeholder="Select Cluster" display="chip" [showClear]="true" />
                    <p-multiSelect [options]="hierarchyData.City | hierarchyFilter:'RegionName':formData['Region'].value" formControlName="City" 
                        optionLabel="CityName" placeholder="Select City Name" display="chip" [showClear]="true" />
                    <p-multiSelect [options]="hierarchyData.Outlet | outletFilter:formData['Region'].value:formData['SubRegion'].value:formData['Cluster'].value:formData['City'].value" formControlName="Outlet" 
                        optionLabel="OutletName" placeholder="Select Outlet" display="chip" [showClear]="true" />
                </div>
                <!-- <div class="flex flex-column gap-1 mb-4">
                    <p-button label="Apply" type="submit" severity="danger" [style]="{'width': '300px', 'font-size': '14px'}" (click)="onApplyBtnClick()"></p-button>
                </div> -->
            </div>
        </form>
    </div>
    <ng-template pTemplate="footer">
        <p-button label="Apply" type="submit" severity="danger" [style]="{'width': '100%'}" (click)="onApplyBtnClick()"></p-button>
    </ng-template>
</p-sidebar>